import { IApiEntity } from "./entity.api.interface";

export interface IApiPermission extends IApiEntity {
  idPermission: number
  module: number
  permission: number
}


/**
 * Listado modulos
 */
export enum Modules{
    Users = 10, // Usuarios
    Roles = 20, // Roles
    UsersRoles=30, // Usuarios-Roles
    UsersLocations=40, // Usuarios-Localizaciones
    RolesPermissions=50, // Roles-Permisos
    Clients = 60, // Clientes
    ClientsCenters = 70, // Centros de clientes
    Locations = 80, // Localizaciones
    Countries = 90, // Paises
    Regions = 100, // Provincias
    Cities = 110, // Localidades
    Packagings = 120, //Envases
    PackagingWeights = 130, // Pesos de Envases
    PackagingStatusHistory = 140, // Histórico de Estados de Envases
    Dashboard = 150, // Dashboard
    UsersClients = 160, // Usuarios-Clientes
    Containers = 170, // Contenedores
    SupportCategories = 180, // Categorías de Soporte
    SupportStates = 190, // Estados de Soporte
    SupportTickets = 200, // Tickets de Soporte
    Suppliers = 210, // Proveedores
    ContainerCategories = 220, // Categorías de contenedor
    WasteTypes = 230, // Tipos de residuos
    EanCodes = 240, // Maestro de códigos EAN
    Colors = 250 // Colores
  }

  /**
  * Listado permisos
  */
  export enum Permissions{
    List = 10, // Consulta
    Add = 20, // Alta
    Edit = 30, // Edición
    Delete = 40, // Baja
    Weighty  = 50, // Pesada
    Pickup = 60, // Recogida
    ExportReduced = 70, // Exportación reducida
    ExportComplete = 80, // Exportacion completa
    AgrupatedWeighty = 90, // Agrupación de pesadas
    Workflow = 100, // Configuración del workflow de estados (Estados de Soporte)
    ListOwn = 110 // Consulta restringida solo a los registros propios del usuario (Tickets de Soporte)
  }
